import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-urgency-banner',
  template: `
    <div class="urgency-banner" *ngIf="show">
      <div class="urgency-content">
        <i class="fa fa-fire"></i>
        <span class="urgency-text">{{ message }}</span>
        <button class="cta-button" (click)="onCtaClick()">{{ ctaText }}</button>
      </div>
      <button class="close-btn" (click)="close()">×</button>
    </div>
  `,
  styles: [`
    .urgency-banner {
      position: fixed;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      background: #e74c3c;
      color: white;
      padding: 15px 25px;
      border-radius: 50px;
      box-shadow: 0 8px 30px rgba(0,0,0,0.3);
      z-index: 9999;
      display: flex;
      align-items: center;
      gap: 15px;
      max-width: 90%;
      animation: slideUp 0.5s ease;
    }

    @keyframes slideUp {
      from {
        transform: translateX(-50%) translateY(100px);
        opacity: 0;
      }
      to {
        transform: translateX(-50%) translateY(0);
        opacity: 1;
      }
    }

    .urgency-content {
      display: flex;
      align-items: center;
      gap: 15px;
      flex-wrap: wrap;
    }

    .urgency-content i {
      font-size: 24px;
      animation: pulse 1.5s infinite;
    }

    @keyframes pulse {
      0%, 100% { transform: scale(1); }
      50% { transform: scale(1.2); }
    }

    .urgency-text {
      font-weight: 600;
      font-size: 15px;
    }

    .cta-button {
      background: white;
      color: #ff6b6b;
      border: none;
      padding: 10px 20px;
      border-radius: 25px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s ease;
    }

    .cta-button:hover {
      transform: scale(1.05);
      box-shadow: 0 4px 15px rgba(0,0,0,0.2);
    }

    .close-btn {
      background: rgba(255,255,255,0.2);
      border: none;
      color: white;
      font-size: 24px;
      cursor: pointer;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background 0.3s ease;
    }

    .close-btn:hover {
      background: rgba(255,255,255,0.3);
    }

    @media (max-width: 768px) {
      .urgency-banner {
        bottom: 10px;
        padding: 12px 15px;
        border-radius: 15px;
      }

      .urgency-text {
        font-size: 13px;
      }

      .cta-button {
        padding: 8px 15px;
        font-size: 13px;
      }
    }
  `]
})
export class UrgencyBannerComponent {
  @Input() message: string = '🔥 Limited Seats! Only 5 spots left in this batch';
  @Input() ctaText: string = 'Enroll Now';
  show: boolean = true;

  onCtaClick(): void {
    // Trigger enquiry form
    const event = new CustomEvent('openEnquiry', { 
      detail: { source: 'urgency-banner' } 
    });
    window.dispatchEvent(event);
  }

  close(): void {
    this.show = false;
  }
}
